import { api } from '@/api'

function stripAccentsAndLower(text) {
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
}

const actions = {
  getCardInfos: async ({ commit }, { bin, cart }) => {
    const payload = { bin, cart }
    commit('SET_REQUEST_INFO', true)
    try {
      const {
        data: {
          data: { type, brand },
        },
      } = await api.post('api/v1/step/order/bin-lookup', payload)

      const typeNormalized = stripAccentsAndLower(type)
      const brandNormalized = stripAccentsAndLower(brand)

      commit('SET_CARD_TYPE', typeNormalized)
      commit('SET_CARD_BRAND', brandNormalized)
      return { type: 'success', status: 'success' }
    } catch (error) {
      return { type: 'error', error, status: 'failed' }
    } finally {
      commit('SET_REQUEST_INFO', false)
    }
  },
  resetCard({ commit }) {
    commit('SET_CARD_TYPE', '')
    commit('SET_CARD_BRAND', '')
    commit('SET_SELECTED_TYPE', 'credito')
    commit('SET_REQUEST_INFO', false)
  },
}

export default actions
